import { $AssetModel } from "@atlassiansox/bxp-content-framework";

export function mock$AssetModel({
    id = "asset-123",
    title = "Placeholder image",
    url = "/placeholder/landscape.png",
    width = 1200,
    height = 600
}: Partial<$AssetModel> = {}): $AssetModel {
    return {
        id,
        title,
        url: `/bxp-trello-storybook${url}`,
        width,
        height
    };
}
